import React, { useState } from "react";
import { Card, Grid, Typography, makeStyles, InputLabel, FormControl, Select, MenuItem, Button } from "@material-ui/core";
import Buscador from "../../../../actions/ui/Buscador";
import {
  desSeleccionarAfiliado,
  desSeleccionarEfector,
  desSeleccionarExternos,
  setActiveStepReclamos,
  setDataAfiliado,
  setDataEfector,
  setDataExternos,
  setRecepcionMenu,
} from "../../../../actions/reclamos/reclamosActions";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { MENU_TIPO_INGRESO_RECLAMO, MENU_TIPO_INGRESO_RECLAMO_ARRAY, STEPPER_RECLAMOS_FORM } from "../../../../utils/constants";
import { fetchSubTipoEfectores } from "../../../../actions/tipoSubtipoEfectores";
import { validarSoloUnPermiso } from "../../../../helpers/permisos";
import { RECLAMOS_PERMISOS } from "../../../../utils/permisos";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";




const useStyles = makeStyles((theme) => ({
  title: {
    color: theme.palette.primary.main,
  },
}));

const fechaActual = new Date();

export const ConsultaIngresoReclamos = (props) => {
  const classes = useStyles();
  const tipoBusqueda = "Todos";
  const altaBaja = "Todos";
  const [tipoIngresoReclamo, setTipoIngresoReclamo] = useState(MENU_TIPO_INGRESO_RECLAMO.AFILIADO);
  const { subtipoEfectores } = useSelector(
    (state) => state.tipoSubtipoEfectores
  );

  const dispatch = useDispatch();
  const [value, setValue] = useState(null);
  const [valueEfector, setValueEfector] = useState(null);
  const [cuit, setcuit] = useState("");


  const { permisos: permisosUser } = useSelector((state) => state.auth);


  let rolIngresoReclamoAfiliado = validarSoloUnPermiso(permisosUser,
    RECLAMOS_PERMISOS.INGRESO_AFILIADO
  );

  let rolIngresoReclamoEfector = validarSoloUnPermiso(permisosUser,
    RECLAMOS_PERMISOS.INGRESO_EFECTOR
  );

  let rolIngresoReclamoExternos = validarSoloUnPermiso(permisosUser,
    RECLAMOS_PERMISOS.INGRESO_EXTERNOS
  );



  const resetAfiliado = () => {
    dispatch(desSeleccionarAfiliado());
    dispatch(desSeleccionarEfector());
    dispatch(desSeleccionarExternos());
  };

  const resetValues = () => {
    setValue(null);
    setValueEfector(null)
    setcuit(null);
  }

  const resetMenu = () => {
    dispatch(desSeleccionarAfiliado());
    dispatch(desSeleccionarEfector());
    dispatch(desSeleccionarExternos());

    dispatch(setRecepcionMenu(MENU_TIPO_INGRESO_RECLAMO.DESELECCIONAR));
  }

  useEffect(() => {
    dispatch(fetchSubTipoEfectores());
  }, []);

  useEffect(() => {
    resetAfiliado();
    dispatch(setDataAfiliado(value));
    dispatch(setDataEfector(valueEfector))
    dispatch(setActiveStepReclamos(STEPPER_RECLAMOS_FORM.RECLAMOS_INGRESO));
  }, [value, valueEfector, tipoIngresoReclamo]);

  const handleSave = () => {
    resetAfiliado();
    resetValues();
    dispatch(setDataExternos(cuit))
    dispatch(setActiveStepReclamos(STEPPER_RECLAMOS_FORM.RECLAMOS_INGRESO));

  }


  return (
    <Grid item xs={12} sm={6} lg={5} xl={5}>
      <Grid
        container
        spacing={2}
        justify="center"
        alignItems="center"
        component={Card}
        style={{ marginTop: "2rem", marginBottom: "2rem", padding: "0 1em" }}
      >
        <Grid item style={{ display: "flex", flexDirection: "column" }} xs={tipoIngresoReclamo === MENU_TIPO_INGRESO_RECLAMO.AFILIADO ? 8 : 8}>
          <Typography
            align="center"
            variant="button"
            color="secondary"
            style={{ paddingTop: 6 }}
          >
            <span className={classes.title}>SELECCIONAR INGRESO</span>
          </Typography>
          <FormControl variant="outlined" margin="normal" fullWidth={true}>

            <InputLabel id="demo-simple-select-outlined">
              ingreso Beneficiaria/o o Efector 
            </InputLabel>
            <Select
              onChange={(e) => {
                resetValues();
                resetMenu();
                setTipoIngresoReclamo(parseInt(e.target.value));
              }}
              value={tipoIngresoReclamo}
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              label="Tipo de Contratación"
            >
              {MENU_TIPO_INGRESO_RECLAMO_ARRAY.map((t, index) => (
                <MenuItem key={index}
                  value={t.id}
                  disabled={
                    (t.id === MENU_TIPO_INGRESO_RECLAMO.AFILIADO && !rolIngresoReclamoAfiliado) ||
                    (t.id === MENU_TIPO_INGRESO_RECLAMO.PRESTADOR && !rolIngresoReclamoEfector) ||
                    (t.id === MENU_TIPO_INGRESO_RECLAMO.EXTERNOS && !rolIngresoReclamoExternos)
                  }
                >
                  {t.descripcion}
                </MenuItem>
              ))}

            </Select>
          </FormControl>
        </Grid>
        {tipoIngresoReclamo === MENU_TIPO_INGRESO_RECLAMO.AFILIADO && rolIngresoReclamoAfiliado && (
          <FormControl variant="outlined" margin="normal" fullWidth={true}>
            <Grid
              item
              xs={12}
              md={12}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <Typography
                align="center"
                variant="button"
                color="secondary"
                style={{ paddingTop: 6, padding: 6 }}
              >
                <span className={classes.title}>SELECCIONAR BENEFICIARIA/O</span>
              </Typography>
              <Buscador
                value={value}
                variant="outlined"
                setValue={(val) => setValue(val)}
                label="Apellido y Nombre  |  CUIT  |  DNI  |  Numero Beneficiaria/o"
                noOptionText={"No se encuentra beneficiaria/o"}
                endpoint={(texto) =>
                  `Afiliados/traerPorNombreoDNIoNroAfi/${texto}/${tipoBusqueda}/${altaBaja}`
                }
                getOptionLabel={(option) =>
                  `${option.apellido_y_nombre} ${option.carnet} ${option.cuil} ${option.nro_doc}`
                }
                renderOption={(option) => (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span
                      style={
                        option.fecha_baja === null
                          ? { color: "green" }
                          : { color: "red" }
                      }
                    >
                      {`${option.apellido_y_nombre}`}
                    </span>
                    <span
                      style={{
                        fontSize: 12,
                      }}
                    >
                      {" "}
                      {`Nro Afi:${option.carnet} - CUIL:${option.cuil}`}
                    </span>
                  </div>
                )}
              />
            </Grid>
          </FormControl>
        )}
        {tipoIngresoReclamo === MENU_TIPO_INGRESO_RECLAMO.PRESTADOR && rolIngresoReclamoEfector && (
          <FormControl variant="outlined" margin="normal" fullWidth={true}>
            <Grid
              item
              xs={12}
              md={12}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <Typography
                align="center"
                variant="button"
                color="secondary"
                style={{ paddingTop: 6 }}
              >
                <span className={classes.title}>SELECCIONAR EFECTOR</span>
              </Typography>
              <Buscador
                value={valueEfector}
                variant="outlined"
                setValue={(val) => setValueEfector(val)}
                label="Razon Social  |  CUIT  |  IdEfector "
                noOptionText={"No se encuentra el efector"}
                endpoint={(texto) =>
                  `EfectorFacturacion/Busqueda?parametros=${texto}&todos=${props.todos ?? false
                  }`
                }
                getOptionLabel={(option) => {
                  const subTipoEfector = subtipoEfectores.find(
                    (subTipoEfector) =>
                      subTipoEfector.idSubTipoEfector === option.idSubTipoEfector
                  )?.descripcionSubTipoEfector;
                  return `${option.razonSocial} ${option.cuit} - ${subTipoEfector} -  ${option.efectorDomicilio?.calle} ${option.efectorDomicilio?.nro} ${option.efectorDomicilio?.nro}`;
                }}
                renderOption={(option) => {
                  const subTipoEfector = subtipoEfectores.find(
                    (subTipoEfector) =>
                      subTipoEfector.idSubTipoEfector === option.idSubTipoEfector
                  )?.descripcionSubTipoEfector;
                  return (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span
                        style={{
                          color:
                            option.fechaBaja === null ||
                              option.fechaBaja >= fechaActual.toISOString()
                              ? "green"
                              : "red",
                        }}
                      >{`${option.razonSocial} ${option.cuit} - ${subTipoEfector} -  ${option.efectorDomicilio?.calle} ${option.efectorDomicilio?.nro}`}</span>
                    </div>
                  );
                }}
              />
            </Grid>
          </FormControl>
        )}
        {tipoIngresoReclamo === MENU_TIPO_INGRESO_RECLAMO.EXTERNOS && rolIngresoReclamoExternos && (
          <FormControl variant="outlined" margin="normal" fullWidth={true}>
            <Grid
              item
              xs={12}
              md={12}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <Typography
                align="center"
                variant="button"
                color="secondary"
                style={{ paddingTop: 6 }}
              >
                <span className={classes.title}>INGRESE CUIL / CUIT</span>
              </Typography>
              <ValidatorForm onSubmit={handleSave}>
                <TextValidator
                  margin="normal"
                  label="CUIT o CUIL"
                  name="cuit"
                  value={cuit}
                  autoComplete="off"
                  onChange={(e) => setcuit(e.target.value)}
                  fullWidth
                  style={{ paddingRight: "0.5rem" }}
                  validators={["required"]}
                  errorMessages={["El código es requerido"]}
                />
                <div
                  style={{
                    margin: '1rem 0',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-evenly',
                  }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    //disabled={props.disabled}
                    color="primary"
                  >
                    Guardar
                  </Button>
                </div>
              </ValidatorForm>
            </Grid>
          </FormControl>
        )}
      </Grid>

    </Grid >

    // <Grid item xs={12} sm={5} lg={4} xl={3}>
    //   <Grid
    //     container
    //     spacing={1}
    //     justify="center"
    //     alignItems="center"
    //     component={Card}
    //     style={{ marginTop: "2rem", marginBottom: "2rem", padding: "0 1em" }}
    //   >
    //     <Grid item xs={12}>
    //       {/* <Grid container justify="center" alignItems="center">
    //         <Grid
    //           item
    //           xs={12}
    //           md={6}
    //           style={{ display: "flex", flexDirection: "column" }}
    //         >
    //           <Typography
    //             align="center"
    //             variant="button"
    //             color="secondary"
    //             style={{ paddingTop: 6 }}
    //           >
    //             <span className={classes.title}>SELECCIONAR BENEFICIARIA/O</span>
    //           </Typography>
    //         </Grid>
    //       </Grid> */}
    //     </Grid>

    //     <Grid item xs={12} style={{ marginBottom: "1em" }}>
    //       {/* <Buscador
    //         value={value}
    //         variant="outlined"
    //         setValue={(val) => setValue(val)}
    //         label="Apellido y Nombre  |  CUIT  |  DNI  |  Numero Beneficiaria/o"
    //         noOptionText={"No se encuentra beneficiaria/o"}
    //         endpoint={(texto) =>
    //           `Afiliados/traerPorNombreoDNIoNroAfi/${texto}/${tipoBusqueda}/${altaBaja}`
    //         }
    //         getOptionLabel={(option) =>
    //           `${option.apellido_y_nombre} ${option.carnet} ${option.cuil} ${option.nro_doc}`
    //         }
    //         renderOption={(option) => (
    //           <div style={{ display: "flex", flexDirection: "column" }}>
    //             <span
    //               style={
    //                 option.fecha_baja === null
    //                   ? { color: "green" }
    //                   : { color: "red" }
    //               }
    //             >
    //               {`${option.apellido_y_nombre}`}
    //             </span>
    //             <span
    //               style={{
    //                 fontSize: 12,
    //               }}
    //             >
    //               {" "}
    //               {`Nro Afi:${option.carnet} - CUIL:${option.cuil}`}
    //             </span>
    //           </div>
    //         )}
    //       /> */}
    //     </Grid>
    //   </Grid>
    // </Grid>
  );
};
